import React from 'react';
import {createBrowserRouter} from 'react-router-dom';
import './index.css';

// components
import Root from './components/Root/Root';
import Error404 from './components/Errors/Error404';
import OpportunityDetail from './components/Opportunity/OpportunityDetail';
import Login from './components/Login/Login';
import DeliveryList from './components/Delivery/DeliveryList';
import NotificationList from "./components/Notification/NotificationList";
import TaskMyBoard from "./components/Task/TaskMyBoard";
import OpportunityReport from "./components/Opportunity/OpportunityReport";
import AccountDetail from "./components/Account/AccountDetail";
import AccountList from "./components/Account/AccountList";
import ContactList from "./components/Contact/ContactList";
import KpiMyList from "./components/Kpi/KpiMyList";
import KpiSubordinateList from "./components/Kpi/KpiSubordinateList";
import PermissionReport from "./components/Permission/PermissionReport";
import FeatureRequestIdeaList from "./components/FeatureRequest/FeatureRequestIdeaList";
import FeatureRequestBugList from "./components/FeatureRequest/FeatureRequestBugList";
import FeatureRequestTechList from "./components/FeatureRequest/FeatureRequestTechList";
import FeatureRequestDetail from "./components/FeatureRequest/FeatureRequestDetail";
import ContactDetail from "./components/Contact/ContactDetail";
import TaskOwnerBoard from "./components/Task/TaskOwnerBoard";
import TaskMyCompleted from "./components/Task/TaskMyCompleted";
import TaskOwnerCompleted from "./components/Task/TaskOwnerCompleted";
import DeliverySubordinateLists from "./components/Delivery/DeliverySubordinateLists";
import EmployeeBonusList from "./components/Employee/EmployeeBonusList";
import EmployeeDetail from "./components/Employee/EmployeeDetail";
import EmployeeList from "./components/Employee/EmployeeList";
import DeliveryAdmin from "./components/Admin/DeliveryAdmin";
import RouteAdmin from "./components/Admin/RouteAdmin";
import LeadIncomingList from "./components/Lead/LeadIncomingList";
import LeadOutgoingList from "./components/Lead/LeadOutgoingList";
import LeadDetail from "./components/Lead/LeadDetail";
import TaskMyCalendar from "./components/Task/TaskMyCalendar";
import TaskSubscriberCalendar from "./components/Task/TaskSubscriberCalendar";
import RouteList from "./components/Route/RouteList";
import RouteSubordinateLists from "./components/Route/RouteSubordinateLists";
import VacationList from "./components/Vacation/VacationList";
import Profile from "./components/Profile/Profile";
import IdeaMap from "./components/Idea/IdeaMap";
import WebinarList from "./components/Hub/WebinarList";
import WebinarDetail from "./components/Hub/WebinarDetail";
import MarketingUserList from "./components/Hub/MarketingUserList";
import MarketingUserDetail from "./components/Hub/MarketingUserDetail";
import DeliveryStats from "./components/Admin/DeliveryStats";
import OpportunityFinancialReport from "./components/Financial/OpportunityFinancialReport";
import BaseHomePage from "./components/HomePage/BaseHomePage";
import CertificateList from "./components/Certificate/CertificateList";
import PaymentList from "./components/Payment/PaymentList";
import Calculator from "./components/Calculator/Calculator";
import FinancialModel from "./components/Financial/FinancialModel";
import CourseList from "./components/Learning/CourseList";
import CourseDetail from "./components/Learning/CourseDetail";
import IdeaList from "./components/Idea/IdeaList";
import FinancialReport from "./components/Financial/FinanceReport";
import LeadWaitingList from "./components/Lead/LeadWaitingList";
import CalculatorList from "./components/Calculator/CalculatorList";
import ContractList from "./components/Contract/ContractList";
import IncomingLetterList from "./components/IncomingLetter/IncomingLetterList";
import LetterList from "./components/Letter/LetterList";
import ApplicantList from "./components/HR/ApplicantList";
import ApplicantDetail from "./components/HR/ApplicantDetail";
import ChecklistTypeList from "./components/Checklist/ChecklistTypeList";
import ChecklistOptionList from "./components/Checklist/ChecklistOptionList";
import ChecklistQuestionList from "./components/Checklist/ChecklistQuestionList";
import ChecklistTypeDetail from "./components/Checklist/ChecklistTypeDetail";
import Platformer from "./components/Games/Platformer/Platformer";
import UltimateAdmin from "./components/Admin/UltimateAdmin";
import KpiAllList from "./components/Kpi/KpiAllList";
import LaborReport from "./components/Financial/LaborReport";
import OpportunityCommentCenter from "./components/Opportunity/OpportunityCommentCenter";
import CallList from "./components/Communication/CallList";
import SliceList from "./components/Slice/SliceList";
import OpportunitiesEvaluation from "./components/Opportunity/OpportunitiesEvaluation";
import BankTransactionList from "./components/BankTransaction/BankTransactionList";
import PresentationList from "./components/Presentation/PresenationList";
import HolidayList from "./components/Holiday/HolidayList";
import FinancialModelList from "./components/Financial/FinancialModelList";
import WikiPageDetail from "./components/WikiPage/WikiPageDetail";
import WikiPageList from "./components/WikiPage/WikiPageList";
import Messenger from "./components/Messenger/Messenger";
import NewQuoteList from "./components/NewQuote/NewQuoteList";
import RoadRunner from "./components/Games/RoadRunner/RoadRunner";
import AgentList from "./components/AI/AgentList";
import AgentDetail from "./components/AI/AgentDetail";
import AgentRunList from "./components/AI/AgentRunList";
import AgentRunDetail from "./components/AI/AgentRunDetail";
import MLHostList from "./components/AI/MLHostList";
import MLHostDetail from "./components/AI/MLHostDetail";
import MaterialList from "./components/Material/MaterialList";
import MaterialDetail from "./components/Material/MaterialDetail";
import OverheadPeriodicList from "./components/Financial/OverheadPeriodicList";
import OverheadOnceList from "./components/Financial/OverheadOnceList";


const router = createBrowserRouter(
    [
        {
            path: '/login/',
            element: <Login/>,
            errorElement: <Error404/>,
        },
        {
            path: '/',
            element: <Root/>,
            errorElement: <Error404/>,
            children: [
                {
                    path: '',
                    element: <BaseHomePage />,
                },
                {
                    path: 'messenger',
                    children: [
                        {
                            path: '',
                            element: <Messenger />,
                        },
                    ]
                },
                {
                    path: 'profile',
                    children: [
                        {
                            path: '',
                            element: <Profile />,
                        },
                    ]
                },
                {
                    path: 'notification/',
                    children: [
                        {
                            path: '',
                            element: <NotificationList/>,
                        },
                        {
                            path: 'page/:pageNumber',
                            element: <NotificationList/>,
                        },
                        {
                            path: 'detail/:notificationId',
                            element: <NotificationList/>,
                        },
                    ],
                },
                {
                    path: 'slice',
                    children: [
                        {
                            path: 'open',
                            element: <SliceList
                                url={'slice/open'}
                                title={'Мои активные срезы'}
                                queryParams={{
                                    post_week_completed: false,
                                }}
                            />,
                        },
                        {
                            path: 'open/page/:pageNumber',
                            element: <SliceList
                                url={'slice/open'}
                                title={'Мои активные срезы'}
                                queryParams={{
                                    post_week_completed: false,
                                }}
                            />,
                        },
                        {
                            path: 'completed',
                            element: <SliceList
                                url={'slice/completed'}
                                title={'Мои завершенные срезы'}
                                queryParams={{
                                    pre_week_completed: true,
                                    post_week_completed: true,
                                }}
                            />,
                        },
                        {
                            path: 'completed/page/:pageNumber',
                            element: <SliceList
                                url={'slice/completed'}
                                title={'Мои завершенные срезы'}
                                queryParams={{
                                    pre_week_completed: true,
                                    post_week_completed: true,
                                }}
                            />,
                        },
                    ]
                },

                {
                    path: 'account',
                    children: [
                        {
                            path: '',
                            element: <AccountList />,
                        },
                        {
                            path: 'page/:pageNumber',
                            element: <AccountList />,
                        },
                        {
                            path: 'detail/:accountId',
                            element: <AccountDetail />,
                        },
                    ]
                },
                {
                    path: 'contact',
                    children: [
                        {
                            path: '',
                            element: <ContactList />,
                        },
                        {
                            path: 'page/:pageNumber',
                            element: <ContactList />,
                        },
                        {
                            path: 'detail/:contactId',
                            element: <ContactDetail />,
                        },
                    ]
                },
                {
                    path: 'call',
                    children: [
                        {
                            path: '',
                            element: <CallList />,
                        },
                        {
                            path: 'page/:pageNumber',
                            element: <CallList />,
                        },
                    ]
                },
                {
                    path: 'quote',
                    children: [
                        {
                            path: '',
                            element: <NewQuoteList />,
                        },
                        {
                            path: 'page/:pageNumber',
                            element: <NewQuoteList />,
                        },
                    ]
                },
                {
                    path: 'opportunity',
                    children: [
                        {
                            path: 'report',
                            element: <OpportunityReport />,
                        },
                        {
                            path: 'evaluation',
                            element: <OpportunitiesEvaluation />,
                        },
                        {
                            path: 'comments',
                            element: <OpportunityCommentCenter />,
                        },
                        {
                            path: 'detail/:opportunityId',
                            element: <OpportunityDetail />,
                        },
                    ]
                },
                {
                    path: 'kpi',
                    children: [
                        {
                            path: 'my',
                            element: <KpiMyList />,
                        },
                        {
                            path: 'subordinate',
                            element: <KpiSubordinateList />,
                        },
                        {
                            path: 'all',
                            element: <KpiAllList />,
                        },

                    ]
                },
                {
                    path: 'delivery/',
                    children: [
                        {
                            path: 'my',
                            element: <DeliveryList/>,
                        },
                        {
                            path: 'subordinate',
                            element: <DeliverySubordinateLists/>
                        },
                    ],
                },
                {
                    path: 'route/',
                    children: [
                        {
                            path: 'my',
                            element: <RouteList/>,
                        },
                        {
                            path: 'subordinate',
                            element: <RouteSubordinateLists/>
                        }
                    ],
                },
                {
                    path: 'task',
                    children: [
                        {
                            path: 'my',
                            element: <TaskMyBoard />,
                        },
                        {
                            path: 'mycalendar',
                            element: <TaskMyCalendar />,
                        },
                        {
                            path: 'calendar/:subscriberId',
                            element: <TaskSubscriberCalendar />,
                        },
                        {
                            path: 'owner',
                            element: <TaskOwnerBoard />,
                        },
                        {
                            path: 'completed',
                            element: <TaskMyCompleted />
                        },
                        {
                            path: 'completed/page/:pageNumber',
                            element: <TaskMyCompleted />,
                        },
                        {
                            path: 'ownercompleted',
                            element: <TaskOwnerCompleted />
                        },
                        {
                            path: 'ownercompleted/page/:pageNumber',
                            element: <TaskOwnerCompleted />,
                        },
                        {
                            path: 'report',
                            element: <LaborReport
                                calculatorURL={'calculator/safe_report/'}
                                employeeReportURL={'employee/safe_report/'}
                                showForecast={false}
                            />
                        },
                    ]
                },
                {
                    path: 'idea/',
                    children: [
                        {
                            path: '',
                            element: <IdeaList />,
                        },
                        {
                            path: 'page/:pageNumber',
                            element: <IdeaList />,
                        },
                        {
                            path: 'map/:rootId',
                            element: <IdeaMap/>
                        }
                    ],
                },
                {
                    path: 'agent/',
                    children: [
                        {
                            path: '',
                            element: <AgentList />,
                        },
                        {
                            path: 'page/:pageNumber',
                            element: <AgentList />,
                        },
                        {
                            path: 'detail/:agentId',
                            element: <AgentDetail />
                        }
                    ],
                },
                {
                    path: 'mlhost/',
                    children: [
                        {
                            path: '',
                            element: <MLHostList />,
                        },
                        {
                            path: 'page/:pageNumber',
                            element: <MLHostList />,
                        },
                        {
                            path: 'detail/:mlhostId',
                            element: <MLHostDetail />
                        }
                    ],
                },
                {
                    path: 'agent_run/',
                    children: [
                        {
                            path: '',
                            element: <AgentRunList />,
                        },
                        {
                            path: 'page/:pageNumber',
                            element: <AgentRunList />,
                        },
                        {
                            path: 'detail/:agentRunId',
                            element: <AgentRunDetail />
                        }
                    ],
                },
                {
                    path: 'admin',
                    children: [
                        {
                            path: 'ultimate',
                            element: <UltimateAdmin />,
                        },
                        {
                            path: 'permission',
                            element: <PermissionReport />,
                        },
                        {
                            path: 'delivery',
                            element: <DeliveryAdmin />,
                        },
                        {
                            path: 'delivery_stats',
                            element: <DeliveryStats />
                        },
                        {
                            path: 'route',
                            element: <RouteAdmin />,
                        },
                        {
                            path: 'checklist_type',
                            element: <ChecklistTypeList />,
                        },
                        {
                            path: 'checklist_type/detail/:checklistTypeId',
                            element: <ChecklistTypeDetail />,
                        },
                        {
                            path: 'checklist_question',
                            element: <ChecklistQuestionList />,
                        },
                        {
                            path: 'checklist_option',
                            element: <ChecklistOptionList />,
                        },
                    ]
                },
                {
                    path: 'letter',
                    children: [
                        {
                            path: '',
                            element: <LetterList />,
                        },
                        {
                            path: 'page/:pageNumber',
                            element: <LetterList />,
                        },
                    ]
                },
                {
                    path: 'incoming_letter',
                    children: [
                        {
                            path: '',
                            element: <IncomingLetterList />,
                        },
                        {
                            path: 'page/:pageNumber',
                            element: <IncomingLetterList />,
                        },
                    ]
                },
                {
                    path: 'hr',
                    children: [
                        {
                            path: 'applicant',
                            element: <ApplicantList />,
                        },
                        {
                            path: 'applicant/page/:pageNumber',
                            element: <ApplicantList />,
                        },
                        {
                            path: 'applicant/detail/:applicantId',
                            element: <ApplicantDetail />,
                        },
                        {
                            path: 'vacation',
                            element: <VacationList />,
                        },
                        {
                            path: 'vacation/page/:pageNumber',
                            element: <VacationList/>,
                        },
                        {
                            path: 'holiday',
                            element: <HolidayList />,
                        },
                        {
                            path: 'holiday/page/:pageNumber',
                            element: <HolidayList/>,
                        },
                    ]
                },
                {
                    path: 'marketing',
                    children: [
                        {
                            path: 'presentation',
                            element: <PresentationList />,
                        },
                        {
                            path: 'presentation/page/:pageNumber',
                            element: <PresentationList />,
                        },
                    ]
                },
                {
                    path: 'hub',
                    children: [
                        {
                            path: 'webinar',
                            element: <WebinarList />,
                        },
                        {
                            path: 'webinar/page/:pageNumber',
                            element: <WebinarList />,
                        },
                        {
                            path: 'webinar/detail/:webinarId',
                            element: <WebinarDetail />,
                        },
                        {
                            path: 'marketing_user',
                            element: <MarketingUserList />,
                        },
                        {
                            path: 'marketing_user/page/:pageNumber',
                            element: <MarketingUserList/>,
                        },
                        {
                            path: 'marketing_user/detail/:userId',
                            element: <MarketingUserDetail />,
                        },
                    ]
                },
                {
                    path: 'financial',
                    children: [
                        {
                            path: 'opportunity_financial_report',
                            element: <OpportunityFinancialReport />
                        },
                        {
                            path: 'calculator',
                            element: <CalculatorList />
                        },
                        {
                            path: 'calculator/page/:pageNumber',
                            element: <CalculatorList />
                        },
                        {
                            path: 'calculator/detail/:calculatorId',
                            element: <Calculator />,
                        },
                        {
                            path: 'model',
                            element: <FinancialModelList />
                        },
                        {
                            path: 'model/page/:pageNumber',
                            element: <FinancialModelList />
                        },
                        {
                            path: 'model/detail/:modelId',
                            element: <FinancialModel />,
                        },
                        {
                            path: 'bank_transaction',
                            element: <BankTransactionList />
                        },
                        {
                            path: 'bank_transaction/page/:pageNumber',
                            element: <BankTransactionList />
                        },
                        {
                            path: 'report',
                            element: <FinancialReport />
                        },
                        {
                            path: 'labor',
                            element: <LaborReport
                                calculatorURL={'calculator/report/'}
                                employeeReportURL={'employee/report/'}
                                showCalendar={true}
                                showForecast={true}
                            />
                        },
                        {
                            path: 'bonus',
                            element: <EmployeeBonusList />,
                        },
                        {
                            path: 'bonus/page/:pageNumber',
                            element: <EmployeeBonusList/>,
                        },
                        {
                            path: 'overhead_once',
                            element: <OverheadOnceList />,
                        },
                        {
                            path: 'overhead_once/page/:pageNumber',
                            element: <OverheadOnceList/>,
                        },
                        {
                            path: 'overhead_periodic',
                            element: <OverheadPeriodicList />,
                        },
                        {
                            path: 'overhead_periodic/page/:pageNumber',
                            element: <OverheadPeriodicList/>,
                        },
                    ],
                },
                {
                    path: 'employee',
                    children: [
                        {
                            path: '',
                            element: <EmployeeList />,
                        },
                        {
                            path: 'page/:pageNumber',
                            element: <EmployeeList />,
                        },
                        {
                            path: 'detail/:employeeId',
                            element: <EmployeeDetail />,
                        },
                    ]
                },
                {
                    path: 'feature_request',
                    children: [
                        {
                            path: 'detail/:featureRequestId',
                            element: <FeatureRequestDetail />,
                        },
                        {
                            path: 'idea',
                            element: <FeatureRequestIdeaList />,
                        },
                        {
                            path: 'idea/page/:pageNumber',
                            element: <FeatureRequestIdeaList/>,
                        },
                        {
                            path: 'bug',
                            element: <FeatureRequestBugList />,
                        },
                        {
                            path: 'bug/page/:pageNumber',
                            element: <FeatureRequestBugList/>,
                        },
                        {
                            path: 'tech',
                            element: <FeatureRequestTechList />,
                        },
                        {
                            path: 'tech/page/:pageNumber',
                            element: <FeatureRequestTechList/>,
                        },

                    ]
                },
                {
                    path: 'lead',
                    children: [
                        {
                            path: 'detail/:leadId',
                            element: <LeadDetail />,
                        },
                        {
                            path: 'incoming',
                            element: <LeadIncomingList />,
                        },
                        {
                            path: 'incoming/page/:pageNumber',
                            element: <LeadIncomingList/>,
                        },
                        {
                            path: 'outgoing',
                            element: <LeadOutgoingList />,
                        },
                        {
                            path: 'outgoing/page/:pageNumber',
                            element: <LeadOutgoingList/>,
                        },
                        {
                            path: 'waiting',
                            element: <LeadWaitingList />,
                        },
                        {
                            path: 'waiting/page/:pageNumber',
                            element: <LeadWaitingList/>,
                        },
                    ]
                },
                {
                    path: 'contract',
                    children: [
                        {
                            path: 'contract',
                            element: <ContractList />
                        },
                        {
                            path: 'contract/page/:pageNumber',
                            element: <ContractList />,
                        },
                        {
                            path: 'certificate',
                            element: <CertificateList />
                        },
                        {
                            path: 'certificate/page/:pageNumber',
                            element: <CertificateList />,
                        },
                        {
                            path: 'payment',
                            element: <PaymentList />
                        },
                        {
                            path: 'payment/page/:pageNumber',
                            element: <PaymentList />
                        },
                    ]
                },
                {
                    path: 'course',
                    children: [
                        {
                            path: '',
                            element: <CourseList />,
                        },
                        {
                            path: 'page/:pageNumber',
                            element: <CourseList />,
                        },
                        {
                            path: 'detail/:courseId',
                            element: <CourseDetail />,
                        },
                    ]
                },
                {
                    path: 'wiki_page',
                    children: [
                        {
                            path: '',
                            element: <WikiPageList />,
                        },
                        {
                            path: 'page/:pageNumber',
                            element: <WikiPageList />,
                        },
                        {
                            path: 'detail/:wikiPageId',
                            element: <WikiPageDetail />,
                        },
                    ]
                },
                {
                    path: 'material',
                    children: [
                        {
                            path: '',
                            element: <MaterialList />,
                        },
                        {
                            path: 'page/:pageNumber',
                            element: <MaterialList />,
                        },
                        {
                            path: 'detail/:materialId',
                            element: <MaterialDetail />,
                        },
                    ]
                },
                {
                    path: 'games',
                    children: [
                        {
                            path: 'platformer',
                            element: <Platformer />,
                        },
                        {
                            path: 'road_runner',
                            element: <RoadRunner />,
                        },
                    ]
                },
            ],
        },
    ]
);

export default router;